'use client'
import HeroPrimary from "@/components/sections/hero-banners/HeroPrimary";
import {useState} from 'react';
import {useTransitionState} from 'react-transition-state';
import Transition from '@/components/shared/transitions/Transition';
import ForgotPasswordPrimary from '@/components/sections/forgot-password/ForgotPasswordPrimary';
import ConfirmEmailCodePrimary from '@/components/sections/forgot-password/ConfirmEmailCodePrimary';
import ChangePasswordPrimary from '@/components/sections/forgot-password/ChangePasswordPrimary';

export default function ForgotPasswordMain({ currency, background }) {
  const [email, setEmail] = useState(null);
  const [code, setCode] = useState(null);
  
  const transitionProps = {
    timeout: 300,
    mountOnEnter: true,
    unmountOnExit: true,
    preEnter: true,
  };
  
  const [state1, toggle1] = useTransitionState({
    ...transitionProps,
    initialEntered: true,
  });
  const [state2, toggle2] = useTransitionState(transitionProps);
  const [state3, toggle3] = useTransitionState(transitionProps);
  
  const toggleTo2 = () => {
    toggle1();
    setTimeout(() => toggle2(), 300);
  };
  
  const toggleTo3 = () => {
    toggle2();
    setTimeout(() => toggle3(), 300);
  };

  return (
      <main>
        <HeroPrimary noText background={background} />
        <Transition state={state1}>
          <ForgotPasswordPrimary
              setEmail={setEmail}
              nextTick={toggleTo2}
          />
        </Transition>
        <Transition state={state2}>
          <ConfirmEmailCodePrimary
              email={email}
              setCode={setCode}
              nextTick={toggleTo3}
          />
        </Transition>
        <Transition state={state3}>
          <ChangePasswordPrimary
              email={email}
              code={code}
              currency={currency}
          />
        </Transition>
      </main>
  );
};
